import { render, staticRenderFns } from "./Uslugi.vue?vue&type=template&id=e243757a&scoped=true&"
import script from "./Uslugi.vue?vue&type=script&lang=js&"
export * from "./Uslugi.vue?vue&type=script&lang=js&"
import style0 from "./Uslugi.vue?vue&type=style&index=0&id=e243757a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e243757a",
  null
  
)

export default component.exports